let ExperienceData = [
  {
    title: "Geotechnical Engineer - AECOM",
    date: "2017 - 2020",
    description: [
      "Lower Thames Crossing Project: ",
      "Thames Tideway Project: ",
      "Beckton DLR Extension Project: ",
      "Hinkley Point C Nuclear Power Station Project: ",
    ],
    subdescription: [
      [
        "Managed AECOM in-house data management system developed in .NET core to process geotechnical data collected from site",
        "Developed Python scripts to improve the overall process of processing the data",
        "Managed a SQL database to process and clean data",
      ],
      [
        "Carried out finite element analysis on the existing river wall using PLAXIS 2D and 3D to facilitate with the design changes due to changes in the construction sequence",
        "Prepared numerous technical notes and design reports",
      ],
      [
        "Carried out Geotechnical Desk Study to inform the ground model and parameters of the site",
        "Designed building and train equipment foundations",
        "Prepared Geotechnical Design Report",
      ],
      [
        "Carried out rock slope design (ground nails) for slopes of up to 30m high",
        "Processed and monitored a large dataset on the movement of all the rock slopes on site using Excel VBA",
        "Prepared numerous technical note and design reports to facilitate the construction of the rock slopes",
      ],
    ],
  },
];

export default ExperienceData;
